import swal from 'sweetalert2';
import {Observable, Subject} from 'rxjs';

export function TypeInfo(titulo: string, texto: string) {
  swal.fire({
    title: titulo,
    text: texto,
    icon: 'info',
    customClass: {
      confirmButton: 'btn btn-primary',
    },
    confirmButtonText: 'OK',
    buttonsStyling: false,
  });
}

// Info Detail
export function TypeInfoDetails(title: string, html: string) {

  swal.fire({
    title: title,
    icon: 'info',
    html: html,
    customClass: {
      confirmButton: 'btn btn-success'
    },
    confirmButtonText: 'OK',
    buttonsStyling: false,
  });

}

// Error
export function TypeError(titulo: string, texto: string) {
  swal.fire({
    title: titulo,
    text: texto,
    icon: 'error',
    customClass: {
      confirmButton: 'btn btn-primary'
    },
    confirmButtonText: 'OK',
    buttonsStyling: false,
  });
}

// Timer
export function TypeTimer(callback: () => void, title: string, message: string, timer: number) {
  let timerInterval: any;
  swal.fire({
    title: title,
    html: message + ' en <b></b> segundos.',
    timer: timer,
    timerProgressBar: true,
    showCancelButton: true,
    cancelButtonText: 'Continuar',
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      swal.showLoading();
      const b = swal.getHtmlContainer()?.querySelector('b');
      timerInterval = setInterval(() => {
        if (b && swal.getTimerLeft()) {
          b.textContent = Math.ceil(swal.getTimerLeft()! / 1000).toString();
        }
      }, 100);
    },
    willClose: () => {
      clearInterval(timerInterval);
    }
  }).then((result) => {
    if (result.dismiss === swal.DismissReason.timer) {
      callback(); // Se ejecuta solo si el timer termina
    }
  });

}


// Success
export function TypeSuccess(titulo: string, texto: string) {
  swal.fire({
    title: titulo,
    text: texto,
    icon: 'success',
    customClass: {
      confirmButton: 'btn btn-primary',
    },
    confirmButtonText: 'OK',
    buttonsStyling: false,
  });
}

// Error Detail
export function TypeErrorDetails(message: string, trace: string) {
  if (message != null && trace != null) {
    swal.fire({
      title: '<p style=\'font-size:1rem; line-height : 25px; font-weight: normal;\'><b style=\'font-size: 1.2rem;\'>ERROR</b><br>' + message + '</p>',
      icon: 'error',
      html: '<textarea style=\'width: 100%; height: 150px; overflow: auto; text-align: left; font-size: 1rem;\'>' + trace + '</textarea>',
      customClass: {
        confirmButton: 'btn btn-primary'
      },
      confirmButtonText: 'OK',
      buttonsStyling: false,
    });
  }
}

export function TypeInfoDetailsTabla(titulo: string, arreglo: { titulo: string, lista: string[] } []) {
  let tabla = '<div style=\'width: 100%; height: 150px; overflow: auto; text-align: left; font-size: 1rem;\' > '
  tabla += '<ul class= \'list-style-icons\'>'
  for (const fila of arreglo) {
    tabla += '<li>' + fila.titulo + '<ul>'
    for (const mensaje of fila.lista) {
      if (mensaje !== '') {
        tabla += '<li>' + mensaje + '</li>'
      }
    }
    tabla += '</ul></li>'
  }
  tabla += '</ul></div>'
  void swal.fire({
    title: '<p style=\'font-size:1rem; line-height : 25px; font-weight: normal;\'>' +
      '<b style=\'font-size: 1.2rem;\'>RESUMEN</b><br>' + titulo + '</p>',
    icon: 'info',
    html: tabla,
    customClass: {
      confirmButton: 'btn btn-primary'
    },
    confirmButtonText: 'OK',
    buttonsStyling: false,
  });
}

// Input
export function TypeInput(titulo: string): Observable<string> {
  const resultObservable = new Subject<string>();
  swal.fire({
    title: titulo,
    input: 'textarea',
    inputPlaceholder: 'Escribir aquí...',
    icon: 'question',
    confirmButtonColor: '#40C057',
    confirmButtonText: 'Continuar',
    showDenyButton: true,
    denyButtonText: 'Salir',
  }).then((result) => {

    if (result.isDenied) {
      resultObservable.next(null);
      resultObservable.complete();
      return resultObservable.asObservable();
    }

    if (result.isConfirmed) {
      if (result.value.trim() === '') {
        resultObservable.next(null);
        resultObservable.complete();
        return resultObservable.asObservable();
      }
    }

    if (result.value.trim() !== '' && result.isConfirmed) {
      resultObservable.next(result.value);
      resultObservable.complete();
      return resultObservable.asObservable();
    }
  });

  return resultObservable.asObservable();

}


// TypeConfirmation
export function TypeConfirmation(callback: () => void, title: string, text: string, noConfirmed?: () => void) {
  swal.fire({
    title: title,
    text: text,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Sí, continuar',
    cancelButtonText: 'Cancelar'
  }).then((result) => {
      if (result.isConfirmed) {
        callback();
      } else {
        if (noConfirmed !== undefined) {
          noConfirmed();
        }
      }
    }
  );
}




